// extracted by mini-css-extract-plugin
export default {"container":"styles_container__V0ZyP","showOnHover":"styles_showOnHover__Afylg","customCell":"styles_customCell__MdF6a","customCellText":"styles_customCellText__oVxCk"};